import i18n from 'i18next';

interface AgeGroup {
  from: number;
  to: number;
  label: string;
}

const ageGroups: AgeGroup[] = [
  {
    from: 0,
    to: 17,
    get label() {
      return i18n.t('constants:below_18');
    },
  },
  {
    from: 18,
    to: 44,
    get label() {
      return i18n.t('constants:from_18_to_44');
    },
  },
  {
    from: 45,
    to: 60,
    get label() {
      return i18n.t('constants:from_45_to_60');
    },
  },
  {
    from: 61,
    to: 100,
    get label() {
      return i18n.t('constants:above_60');
    },
  },
];

export const determinerAgeGroup = (value?: number | null): AgeGroup | undefined => {
  if (value == null) return undefined;

  return ageGroups.find(({ from, to }) => from <= value && value <= to);
};
